import request from '@/utils/request'

export default {
  getBookList(qry) {
    return request.post('/reference-data/getBooks', qry)
  },
  createBook(createBookReq) {
    return request.post('/reference-data/createBook', createBookReq)
  },
  updateBook(fundBookTeamDTO) {
    return request.post('/reference-data/updateBook', fundBookTeamDTO)
  },
  getBuBooks(masterFundBookId) {
    return request.get(`/reference-data/getBuBooks/${masterFundBookId}`)
  },
}
